import { globalFields } from "./global-fields";

const entityType = {
    fields: [
        globalFields.person.id,
        {
            name: 'personTypeIdentifierId',
            label: 'Person Entity Types',
            validators: {required: false}
        },
    ],
    customFields: [
    ]
};

const primaryInformation = {
    fields: [
        globalFields.person.tags,
        globalFields.person.lastName,
        globalFields.person.firstName,
        globalFields.person.middleName,
        globalFields.person.suffix,
        globalFields.person.unnamed,
        // personAdditionalNames accordion
        {
            name: 'personAdditionalNames',
            label: 'Also known as',
            array: [
                {
                    name: 'typeId',
                    label: 'Type',
                    validators: {}
                },
                globalFields.person.firstName,
                globalFields.person.middleName,
                globalFields.person.lastName,
                globalFields.person.suffix,
                {
                    name: 'unparsedName',
                    label: 'Name',
                    validators: {}
                },                
                globalFields.id,
                globalFields.masterReferenceId
            ]
        },
        globalFields.person.race,
        globalFields.person.sex,
        globalFields.person.gender,
        globalFields.person.ethnicity,
        // age accordion
        globalFields.person.dateOfBirth,
        globalFields.person.age,
        globalFields.person.isJuvenile,
        {
            name: 'isEstimatedDateOfBirth',
            label: 'Unknown',
            validators: {}
        },
        {
            name: 'ageFrom',
            label: 'Age From',
            validators: {}
        },
        {
            name: 'ageTo',
            label: 'To',
            validators: {}
        },
        {
            name: 'isDeceased',
            label: 'Deceased',
            validators: {}
        },
        globalFields.person.deceasedOn,
        globalFields.id
    ],
    customFields: [
        //comment out we dont need them for now, was proof of concept, can turn on to test
        // {
        //     name: 'customField1',
        //     label: 'Custom 1',
        //     type: PropertyType.Text,
        //     validators: {
        //         required: true
        //     },
        //     position: 1
        // },
        // {
        //     name: 'customField2',
        //     label: 'Custom 2',
        //     type: PropertyType.Numerical,
        //     validators: {
        //         required: true
        //     },
        //     position: 2
        // },
        // {
        //     name: 'customField3',
        //     label: 'Custom 3',
        //     type: PropertyType.SingleSelect,
        //     validators: {
        //         required: true
        //     },
        //     position: 3
        // }
    ]
};

const additionalInformation = {
    fields: [
        {
            name: 'personCitizenships',
            label: 'Citizen Of',
            array: [
                {
                    name: 'countryId',
                    label: 'Country',
                    validators: {}
                },
                {
                    name: 'citizenshipStartDate',
                    label: 'Citizenship Date',
                    validators: {}
                },
                {
                    name: 'citizenshipEndDate',
                    label: 'Revoked Date',
                    validators: {}
                },
                globalFields.masterReferenceId,
                globalFields.id
            ]
        },
        globalFields.person.birthCity,
        globalFields.person.birthStateId,
        globalFields.person.birthCountyId,
        globalFields.person.birthCountryId,
        {
            name: 'personOccupations',
            label: 'Occupation',
            array: [
                {
                    name: 'occupationName',
                    label: 'Occupation',
                    validators: {}
                },
                {
                    name: 'beganOn',
                    label: 'From',
                    validators: {}
                },
                {
                    name: 'endsOn',
                    label: 'To',
                    validators: {}
                },
                {
                    name: 'isPrimary',
                    label: 'Primary',
                    validators: {}
                },
                globalFields.masterReferenceId,
                globalFields.id
            ]
        },
        {
            name: 'personReligions',
            label: 'Religion',
            array: [
                {
                    name: 'religionId',
                    label: 'Religion',
                    validators: {}
                },
                {
                    name: 'isPrimary',
                    label: 'Primary',
                    validators: {}
                },
                globalFields.masterReferenceId,
                globalFields.id
            ]
        },
        globalFields.person.id,
        {
            name: 'justicePersonDetail',
            label: 'justicePersonDetail',
            objects: {
                residentStatusId: {
                    ...globalFields.person.residentStatusId
                },
                maritalStatusId: {
                    ...globalFields.person.maritalStatusId
                }
            }
        }
    ],
    customFields: [
        // {
        //     name: 'customField1',
        //     label: 'Add Info Custom 1',
        //     type: PropertyType.Text,
        //     validators: {
        //         required: true
        //     },
        //     position: 1
        // },
        // {
        //     name: 'customField2',
        //     label: 'Add Info Custom 2',
        //     type: PropertyType.Numerical,
        //     validators: {
        //         required: true
        //     },
        //     position: 2
        // },
        // {
        //     name: 'customField3',
        //     label: 'Add Info Custom 3',
        //     type: PropertyType.SingleSelect,
        //     validators: {
        //         required: true
        //     },
        //     position: 3
        // }
    ]
};

const languages = {
    fields: [
        {
            name: 'personLanguages',
            label: 'Languages',
            array: [                
                {
                    name: 'personId',
                    label: 'Name',
                    validators: {}
                },
                {
                    name: 'comprehends',
                    label: 'Comprehends',
                    validators: {}
                },
                {
                    name: 'reads',
                    label: 'Reads',
                    validators: {}
                },
                {
                    name: 'speaks',
                    label: 'Speaks',
                    validators: {}
                },
                {
                    name: 'hasAccent',
                    label: 'Has Accent',
                    validators: {}
                },
                {
                    name: 'translatorRequired',
                    label: 'Translator Required',
                    validators: {}
                },
                {
                    name: 'speechImpediment',
                    label: 'Speech Impediment',
                    validators: {}
                },
                {
                    name: 'isPrimary',
                    label: 'Primary',
                    validators: {}
                },
                {
                    name: 'languageId',
                    label: 'LanguageID',
                    validators: {}
                },
                globalFields.id,
                globalFields.masterReferenceId
            ]
        },
        globalFields.person.id
    ],
    customFields: [
        // {
        //     name: 'customField1',
        //     label: 'Add Info Custom 1',
        //     type: PropertyType.Text,
        //     validators: {
        //         required: true
        //     },
        //     position: 1
        // },
        // {
        //     name: 'customField2',
        //     label: 'Add Info Custom 2',
        //     type: PropertyType.Numerical,
        //     validators: {
        //         required: true
        //     },
        //     position: 2
        // },
        // {
        //     name: 'customField3',
        //     label: 'Add Info Custom 3',
        //     type: PropertyType.SingleSelect,
        //     validators: {
        //         required: true
        //     },
        //     position: 3
        // }
    ]
};


const gangInformation = {
    fields: [
        {
            name: 'validationFactors',
            label: 'Validation Factors',
            array: [
                {
                    name: 'gangAffiliation',
                    label: 'Gang Affiliation',
                    validators: {
                        required: true
                    }
                },
                {
                    name: 'gangSet',
                    label: 'Gang Set',
                },
                {
                    name: 'gangRank',
                    label: 'Gang Rank',
                },
                {
                    name: 'validationFactorsCount',
                    label: 'Number of Validation Factors'
                },
                {
                    name: 'factors',
                    label: 'Factors',
                    array: [
                        {
                            name: 'validationFactor',
                            label: 'Validation Factor',
                            validators: {
                                required: true
                            }
                        },
                        {
                            name: 'validationDate',
                            label: 'Validation Date',
                            validators: {
                                required: true
                            }
                        },
                        {
                            name: 'validatedBy',
                            label: 'Validated By',
                            validators: {
                                required: true
                            }
                        },
                        {
                            name: 'comment',
                            label: 'Comment'
                        },
                        {
                            name: 'id',
                            label: 'id'
                        },
                        globalFields.masterReferenceId
                    ]
                },
                {
                    name: 'id',
                    label: 'id'
                },
                {
                    name: 'isConfirmedMember',
                    label: 'isConfirmedMember'
                },
                globalFields.masterReferenceId
            ]
        }
    ],
    customFields: []
};

const contactInformation = {
    fields: [
        {
            name: 'personPhoneNumbers',
            label: 'Phone Numbers',
            array: [                
                {
                    name: 'phoneNumberTypeId',
                    label: 'Type',
                    validators: {
                        required: true
                    }
                },
                {
                    name: 'contactValue',
                    label: 'Phone Number',
                    validators: {
                        required: true,
                        pattern: '^\\+?[0-9]{0,3}\\s?\\(?[0-9]{3}\\)?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,7}$'
                    }
                },
                {
                    name: 'contactSuffix',
                    label: 'Extension',
                    validators: {
                        pattern: '^[x,X]?[0-9]+$',
                        maxlength: 20
                    }
                },
                {
                    name: 'isPrimary',
                    label: 'Primary',
                    validators: {}
                },
                globalFields.masterReferenceId
            ]
        },
        {
            name: 'personEmailAddresses',
            label: 'Email',
            array: [
                {
                    name: 'emailAddressTypeId',
                    label: 'Type',
                    validators: {
                        required: true
                    }
                },
                {
                    name: 'contactValue',
                    label: 'Email',
                    validators: {
                        required: true,
                        email: true
                    }
                },
                {
                    name: 'isPrimary',
                    label: 'Primary',
                    validators: {}
                },
                globalFields.masterReferenceId
            ]
        },
        {
            name: 'personWebAddresses',
            label: 'Web Address (URL)',
            array: [
                {
                    name: 'webAddressTypeId',
                    label: 'Type',
                    validators: {
                        required: true
                    }
                },
                {
                    name: 'contactValue',
                    label: 'Web Address',
                    validators: {
                        required: true
                    }
                },
                {
                    name: 'isPrimary',
                    label: 'Primary',
                    validators: {}
                },
                globalFields.masterReferenceId
            ]
        }
    ],
    customFields: []
};

const socialMedia = {
    fields: [
        {
            name: 'personSocialMedia',
            label: 'Social Media',
            array: [
                globalFields.person.socialMediaSiteId,
                globalFields.person.alias,
                globalFields.person.url,
                globalFields.person.username,                
                globalFields.person.password,
                {
                    name: 'id',
                    label: 'id'
                },
                globalFields.masterReferenceId,
                {
                    name: 'socialMediaMasterReferenceId'
                }
            ]
        }
    ],
    customFields: [
        // {
        //     name: 'customField1',
        //     label: 'Add Info Custom 1',
        //     type: PropertyType.Text,
        //     validators: {
        //         required: true
        //     },
        //     position: 1
        // },
        // {
        //     name: 'customField2',
        //     label: 'Add Info Custom 2',
        //     type: PropertyType.Numerical,
        //     validators: {
        //         required: true
        //     },
        //     position: 2
        // },
        // {
        //     name: 'customField3',
        //     label: 'Add Info Custom 3',
        //     type: PropertyType.SingleSelect,
        //     validators: {
        //         required: true
        //     },
        //     position: 3
        // }
    ]
};

const physicalAttributes = {
    fields: [        
        globalFields.person.actualHeight,
        {
            name: 'isHeightKnown',
            label: 'Unknown',
            validators: {}
        },
        globalFields.person.heightFrom,
        globalFields.person.heightTo,
        globalFields.person.actualWeight,
        {
            name: 'isWeightKnown',
            label: 'Unknown',
            validators: {}
        },
        globalFields.person.weightFrom,
        globalFields.person.weightTo,
        globalFields.person.buildId,
        globalFields.person.complexionId,
        globalFields.person.handednessId,
        {
            name: 'personHairAttributes',
            label: 'Hair',
            array: [
                {
                    name: 'typeId',
                    label: 'Type',
                    validators: {}
                },
                {
                    name: 'attributeValue',
                    label: 'Value',
                    validators: {}
                },
                {
                    name: 'isPrimary',
                    label: 'Primary',
                    validators: {}
                },
                globalFields.id,
                globalFields.masterReferenceId
            ]
        },
        {
            name: 'personEyesAttributes',
            label: 'Eyes',
            array: [
                {
                    name: 'typeId',
                    label: 'Type',
                    validators: {}
                },
                {
                    name: 'attributeValue',
                    label: 'Value',
                    validators: {}
                },
                {
                    name: 'isPrimary',
                    label: 'Primary',
                    validators: {}
                },
                globalFields.id,
                globalFields.masterReferenceId
            ]
        },
        {
            name: 'personFacialAttributes',
            label: 'Facial Distinctions',
            array: [
                {
                    name: 'typeId',
                    label: 'Type',
                    validators: {}
                },
                {
                    name: 'attributeValue',
                    label: 'Value',
                    validators: {}
                },
                globalFields.id,
                globalFields.masterReferenceId
            ]
        },
        {
            name: 'personPhysicalDeformitiesAttributes',
            label: 'Amputation/Physical Deformities, Skin Discoloration',
            array: [
                {
                    name: 'typeId',
                    label: 'Type',
                    validators: {}
                },
                {
                    name: 'attributeValue',
                    label: 'Value',
                    validators: {}
                },
                globalFields.id,
                globalFields.masterReferenceId
            ]
        },
        globalFields.person.id,
        globalFields.masterReferenceId
    ],
    customFields: [

    ]
}

const distinguishingCharacteristics = {
    fields: [
        {
            name: 'personDistinguishingCharacteristics',
            label: 'Distinguishing Characteristics',
            array: [                
                globalFields.person.personPhysicalFeatureCategoryId,
                globalFields.person.personPhysicalFeatureNameId,
                {
                    name: 'text',
                    label: 'Description',
                    validators: {}
                },
                globalFields.person.personPhysicalFeatureLocationId,
                globalFields.person.personPhysicalFeatureSubClassId,
                {
                    name: 'id',
                    label: 'id'
                },
                {
                    name: 'personId',
                    label: 'Name',
                    validators: {}
                },
                globalFields.masterReferenceId
            ]
        }
    ],
    customFields: [

    ]
}

const location = {
    fields: [
      {
        name: 'involvement',
        label: 'Involvement',
        validators: {},
      },
      {
        name: 'isPrimary',
        label: 'Primary',
        validators: {},
      },
      {
        name: 'incidentAndAddressId',
        label: 'incidentAndAddressId',
        validators: {},
      },
    ],
    customFields: [],
  };

const incidentAssociation = {
    fields: [
        globalFields.incident.logNumber,
        globalFields.incident.incidentReportType,
        globalFields.incident.reportedOn,
        globalFields.incident.occurredOn,
        globalFields.incident.location,
        globalFields.incident.agency,
        globalFields.incident.age,
        globalFields.incident.involvement,
        globalFields.incident.linkDate,
        globalFields.incident.disposition,
        globalFields.incident.comment,
    ],
};

const personAssociation = {
    fields: [
        {
            name: 'fullName',
            label: 'Name',
            validators: {
            }
        },
        {
            name: 'dobAge',
            label: 'DOB / Age',
            validators: {
            }
        },
        {
            name: 'address',
            label: 'Address',
            validators: {
            }
        },
        {
            name: 'sexRace',
            label: 'Sex, Race',
            validators: {
            }
        },
        {
            name: 'comment',
            label: 'Comment',
            validators: {
            }
        },
        {
            name: 'relationships',
            label: 'Relationships',
            validators: {
            }
        },
        {
            name: 'linkedOn',
            label: 'Linked On',
            validators: {
            }
        },
        globalFields.person.deceasedOn,
        globalFields.person.ethnicity,
    ],
};

const personIdentifiers = {
    fields: [
        {
            name: 'personIdentifiers',
            label: 'Official Issued Numbers',
            array: [                
                {
                    name: 'personIdentifierTypeId',
                    label: 'Type',
                    validators: {
                        required: true
                    }
                },
                {
                    name: 'personIdentificationNumber',
                    label: 'Number',
                    validators: {
                        required: true,
                        maxlength: 25
                    }
                },
                {
                    name: 'personIdentifierStatusId',
                    label: 'Status',
                    validators: {
                    }
                },
                {
                    name: 'issuedOn',
                    label: 'Issue Date',
                    validators: {
                    }
                },
                {
                    name: 'expiresOn',
                    label: 'Expiration Date',
                    validators: {
                    }
                },
                {
                    name: 'identifierState',
                    label: 'State',
                    validators: {
                    }
                },
                {
                    name: 'identifierCountry',
                    label: 'Country',
                    validators: {
                    }
                },
                {
                    name: 'identifierCounty',
                    label: 'County',
                    validators: {
                    }
                },
                {
                    name: 'identifierBranch',
                    label: 'Branch',
                    validators: {
                    }
                },
                {
                    name: 'textLocation',
                    label: 'Country of Birth',
                    validators: {
                    }
                },
                {
                    name: 'identifierClassId',
                    label: 'Category',
                    validators: {
                    }
                },
                {
                    name: 'documentPresented',
                    label: 'Document Presented',
                    validators: {
                    }
                },
                {
                    name: 'isRealId',
                    label: 'Real ID',
                    validators: {
                    }
                },
                {
                    name: 'identifierMunicipality',
                    label: 'Municipality',
                    validators: {
                    }
                },
                {
                    name: 'isAutoGenerated',
                    label: '',
                    validators: {
                    }
                },
                {
                    name: 'isPrimary',
                    label: 'Primary',
                    validators: {
                    }
                },
                globalFields.id,
                globalFields.masterReferenceId
            ]
        }
    ],
    customFields: []
};

const modusOperandis = {
    fields: [
        {
            name: 'modusOperandis',
            label: 'MO',
            array: [
                {
                    name: 'modusOperandiGroup',
                    label: 'MO Group',
                    array: [
                        {
                            name: 'modusOperandiTypeId',
                            label: 'Type',
                            validators: {
                                required: true
                            }
                        },
                        {
                            name: 'modusOperandiCodeId',
                            label: 'Code',
                            validators: {
                            }
                        },
                        {
                            name: 'modusOperandiComment',
                            label: 'Comment',
                            validators: {
                            }
                        },

                    ]
                }
            ]
        }
    ],
    customFields: []
}

const personEmployee = {
    customFields: [],
    fields: [
        {
            name: 'agencyDivisionId',
            label: 'Employee Division',
            validators: {}
        },
        {
            name: 'squadId',
            label: 'Employee Squad',
            validators: {}
        },
        {
            name: 'employeeRole',
            label: 'Employee Type',
            validators: {}
        },
        {
            name: 'officerRankId',
            label: 'Employee Position Rank',
            validators: {}
        },
        {
            name: 'officerBadge',
            label: 'Badge Number',
            validators: {}
        },
        {
            name: 'employeeIdNumber',
            label: 'Employee ID Number',
            validators: {}
        },
        {
            name: 'certificationNumber',
            label: 'Certification Number',
            validators: {}
        },
        {
            name: 'organizationId',
            label: 'Organization',
            validators: {}
        },
        {
            name: 'isActive',
            label: 'Active Employee',
            validators: {}
        },
        {
            name: 'inactiveOn',
            label: 'Inactive On',
            validators: {}
        },
        {
            name: 'officerCADId',
            label: 'Officer CAD ID',
            validators: {}
        }
    ]
}

export const personEntityTypeFields = {
    fields: [...entityType.fields],
    customFields: [...entityType.customFields]
};

export const personEmployeeFields = {
    fields: [...personEmployee.fields],
    customFields: [...personEmployee.customFields]
};

export const personPrimaryInformationFields = {
    fields: [...primaryInformation.fields],
    customFields: [...primaryInformation.customFields]
};

export const personAdditionalInformationFields = {
    fields: [...additionalInformation.fields],
    customFields: [...additionalInformation.customFields]
};

export const personContactInformationFields = {
    fields: [...contactInformation.fields],
    customFields: [...contactInformation.customFields]
};

export const personGangInformationFields = {
    fields: [...gangInformation.fields],
    customFields: [...gangInformation.customFields]
}

export const personLanguagesFields = {
    fields: [...languages.fields],
    customFields: [...languages.customFields]
};

export const personSocialMediaFields = {
    fields: [...socialMedia.fields],
    customFields: [...socialMedia.customFields]
}

export const personPhysicalAttributesFields = {
    fields: [...physicalAttributes.fields],
    customFields: [...physicalAttributes.customFields]
}

export const personDistinguishingCharacteristicsFields = {
    fields: [...distinguishingCharacteristics.fields],
    customFields: [...distinguishingCharacteristics.customFields]
}

export const personIncidentAssociationFields = {
    fields: [...incidentAssociation.fields],
    customFields: []
}

export const personAssociationFields = {
    fields: [...personAssociation.fields],
    customFields: []
}

export const personIdentifierFields = {
    fields: [...personIdentifiers.fields],
    customFields: [...personIdentifiers.customFields]
}

export const personModusOperandiFields = {
    fields: [...modusOperandis.fields],
    customFields: [...modusOperandis.customFields]
}

export const personLocationFields = {
    fields: [...location.fields],
    customFields: [...location.customFields]
}